import React from 'react';
import styles from './Form.module.css';

export const Checkbox = ({ label, className, ...rest }) => (
  <label className={`${styles.radioLabel} ${className}`}>
    <input type='checkbox' className={styles.radio} {...rest} />
    {label}
  </label>
);
